export function addMissingIDs(peaks, options = {}) {
    const { output = structuredClone(peaks) } = options;
    for (const peak of output) {
        if (!('id' in peak)) {
            peak.id = crypto.randomUUID();
        }
    }
    return output;
}
//# sourceMappingURL=addMissingIDs.js.map